import { gql } from "@apollo/client";

export const EXCHANGE_GA_CODE = gql`
  mutation ExchangeGaCode($input: GaExchangeCodeInput!) {
    exchangeGaCode(input: $input) {
      success
      email
      message
      error
      error_type
      error_message
    }
  }
`;

export const DISCONNECT_GA = gql`
  mutation DisconnectGa($email: String) {
    disconnectGa(email: $email) {
      success
      message
    }
  }
`;
